import { useMemo } from 'react'
import { Trans } from 'react-i18next'

import { ActionFlag, BuilderPage } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useAppPagesContext } from '@/context/AppPagesContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'
import { formatFormDetailScreenTitle } from '@/utils/builder/app-builder'
import { BackButton } from '@/components/BackButton'

import PageSetting from './PageSetting'

function PagePanelEdit({ page: curPage }: { page: BuilderPage }) {
  const { pageAction, setPageAction } = useAppBuilderContext()
  const { pages } = useAppPagesContext()

  const pageIdx = useMemo(() => {
    return pages?.findIndex((p) => p.id === curPage.id) ?? -1
  }, [pages, curPage.id])

  const pageTitle = useVariableTextSingleCell(curPage.title)
  const isDetailScreen = !!curPage.tableId


  const isFormAddScreen = !!curPage.tableId && curPage.title.startsWith('form-add')
  const isFormUpdateScreen = !!curPage.tableId && curPage.title.startsWith('form-detail')

  const renderPageLabel = () => {
    if (isFormAddScreen || isFormUpdateScreen) {
      return formatFormDetailScreenTitle(pageTitle)
    }
    if (isDetailScreen) {
      return `${pageTitle} details`
    }
    return pageTitle
  }

  return (
    <>
      <div className='flex items-center'>
        <BackButton
          bottomBorder
          onClick={() => {
            setPageAction(undefined)
          }}
        />
        {pageAction?.flag === ActionFlag.Edit && (
          <div className='w-full border-b h-12 flex-c justify-end ltr:pr-4 rtl:pl-4 bdr text-m-sm text-primary-500'>
            <div
              className='flex items-center'
              style={{
                maxWidth: '250px',
              }}
            >
              <span className='shrink-0'>
                <Trans>Editing</Trans>&nbsp;
              </span>
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {renderPageLabel()}
              </span>
            </div>
          </div>
        )}
      </div>
      <PageSetting key={`page-${pageIdx}-edit`} pageIdx={pageIdx} page={curPage} />
    </>
  )
}

export default PagePanelEdit
